import { isEmpty } from 'lodash'
import { isNil } from 'lodash-es'

import { PickupDeliveryLocationResponseV1 } from '@forto-dev/customer-master-data-models'

import { AddressDetailsDTO } from '@/clients/booking'

/**
 * Checks if an address is empty by verifying all its values are falsy
 * @param addressDetails The address details object (can be undefined)
 * @returns true if address is empty or undefined, false otherwise
 */
export function isAddressEmpty(addressDetails?: AddressDetailsDTO): boolean {
  return !addressDetails || Object.values(addressDetails).every((v) => !v)
}

export function formatAddressDetails(addr?: AddressDetailsDTO) {
  let str = ''

  if (!addr) {
    return str
  }

  const prependComma = () => {
    if (str !== '') {
      str += ', '
    }
  }
  if (addr.locationName) {
    str += `${addr.locationName}`
  }
  if (addr.place?.street) {
    prependComma()
    str += addr.place?.street
    str += addr.place?.streetNumber ? ` ${addr.place?.streetNumber}` : ''
  }
  if (addr.place?.postalCode) {
    prependComma()
    str += addr.place?.postalCode
  }
  if (addr.place?.city) {
    str += ` ${addr.place?.city}`
  }
  if (!addr.place?.city && addr.place?.state) {
    prependComma()
    str += addr.place?.state
  }
  if (addr.place?.country) {
    prependComma()
    str += addr.place?.country
  }
  return str.trim()
}

/**
 * Creates address details object from a location
 * @param location The location object (can be null)
 * @returns Address details object with addressID or null if location is null
 */
export const createAddressDetailsFromLocation = (
  location: PickupDeliveryLocationResponseV1 | null
): AddressDetailsDTO | null => {
  return !isNil(location) && !isEmpty(location.id)
    ? {
        addressID: location.id,
      }
    : null
}
